import { render } from "./DarkModeSwitch.vue?vue&type=template&id=0573c45e&scoped=true"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=js"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=js"

import "./DarkModeSwitch.vue?vue&type=style&index=0&id=0573c45e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0573c45e"]])

export default __exports__